<template>
  <div class="index">
    <HeaderTop/>
    <div class="w">
      <!-- 轮播 -->
      <div class="swiper-container swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in tableDataBanners" :key="index">
            <!-- <img height="418px" :src="../images/img1.jpg" alt=""> -->
            <img :src="item.carImage == null ? 'http://www.dg-hyundai.com/UploadFile/pic/gzysc1/zanwu.gif' : url + item.carImage.imageName"/>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
      </div>
      <!-- 品牌 -->
      <div class="brands">
        <div class="title">
          <h2>品牌一览</h2>
          <p>———— All brands ————</p>
        </div>
        <div class="brand-box">
          <!-- <div class="car-brand"> 
            <ul>
              <li v-for="item in tableCarBrand.slice(0, pagesMore)" :key="item.id" @mouseover="changeActive($event)" @mouseout="removeActive($event)"> 
                <router-link :to="{path:'/salecar',query: {brandid: item.id}}">
                  <img :src="item.carImage != null ? url + item.carImage.imageName : 'http://www.dg-hyundai.com/_upload/branch/imageresize/s1_20161208163616_20140620074501_logo_1.jpg'"/>
                  <span class="current" >{{item.brandName}}</span>
                </router-link>
              </li>
              <li @mouseover="changeActive($event)" @mouseout="removeActive($event)"> 
                <router-link :to="{path:'/salecar'}">
                  <i class="iconfont icon-gengduo"></i>
                  <span class="current" >其他品牌</span>
                </router-link>
              </li>
            </ul>
          </div> -->

          <div class="box">
            <div class="car-left" v-for="item in tableCarBrand.slice(0, pagesMore)" :key="item.id" @mouseover="changeActive($event)" @mouseout="removeActive($event)">
              <router-link :to="{path:'/salecar',query: {brandid: item.id}}">
                <img :src="item.carImage != null ? url + item.carImage.imageName : 'https://www.kamlung.net:8080/usedcar/upload/usedCar/s1_20161208163616_20140620074501_logo_1.jpg'"/>
                <span class="current" >{{item.brandName}}</span>
              </router-link>
            </div>
            <div class="car-price">
              <ul>
                <li v-for="itemPrice in carPrice" :key="itemPrice.id">
                  <router-link :to="{path:'/salecar', name: 'salecar', params: {minPriceA: itemPrice.minPrice, maxPriceA: itemPrice.maxPrice}}">
                    {{itemPrice.name}}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          
          <div class="box">  
            <div class="car-left" @mouseover="changeActive($event)" @mouseout="removeActive($event)">
              <router-link :to="{path:'/salecar',query: {otherBrand: 1}}">
                <i class="iconfont icon-gengduo"></i>
                <span class="current" >其他品牌</span>
              </router-link>
            </div>
            <div class="car-modal">
              <ul>
                <li v-for="itemModal in carModal" :key="itemModal.carTypeId">
                  <router-link :to="{path:'/salecar',query: {carTypeId: itemModal.carTypeId}}">
                    {{itemModal.carTypeName}}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

        </div>
        <div class="brand-right">
          <h5>我要卖车</h5>
          <p>在线高效评估 高价便捷收车</p>      
          <el-form ref="phoneNoform" :model="phoneNoform" :rules="rules"  class="brand-right-text" @keydown.enter.native="onSubmit">
            <el-form-item prop="phoneNo"> 
              <input type="text" prefix="md-person" v-model="phoneNoform.phoneNo" placeholder="请输入您的手机号码"  size="large" :maxlength="11"/>
            </el-form-item>
            <el-form-item class="brand-right-buttom">
              <input @click="onSubmit($event)" type="button" value="我要卖车"/>
              <input @click="onTo" type="button" value="免费评估"/>
            </el-form-item>  
          </el-form>
        </div>
        <!-- <div class="brands-more"  v-if="pagesMore <= tableCarBrand.length" @click='loadBrands'><i v-if="loadingMore" class="el-icon-loading == true"></i><span>查看更多</span></div>
        <div class="brands-more brands-more-else" v-else >
          <span>暂时没有了</span>
        </div> -->
      </div>
      <!-- 店长推荐 -->
      <div class="recommends">
        <div class="title">
          <h2>店长推荐</h2>
          <p>———— Director recommends ————</p>
        </div>
        <div class="recommends-box">
          <div class="recommends-li" v-for="(item,index) in tableRecommends.slice(0, 4)" :key="index">
            <div class="box">  
              <router-link :to="'/salecar/subsalecar/'+ item.id">
                <img :src="item.carImageList.length == 0 ? 'https://www.kamlung.net:8080/usedcar/upload/usedCar/201922612223.jpg' : url + item.carImageList[0].imageName"/>
              </router-link>
              <div class="recommends-text">
                <router-link :to="'/salecar/subsalecar/'+ item.id">
                  <span>{{item.title}}</span>
                  <h3>￥{{item.price}}万</h3>
                  <!-- <b>万</b> -->
                </router-link>
              </div>
            </div>
            <div class="car-status" v-if="item.status == 3"><span>已售</span></div>
          </div>
        </div>
      </div>
      <!-- 限时抢购 -->
      <div class="sale">
        <div class="title">
          <h2>{{month}}月臻选 限时抢购</h2>
          <p>———— Short SALE ————</p>
        </div>
        <div class="recommends-box">
          <div class="recommends-li" v-for="(item,index) in tableSales.slice(0, 4)" :key="index">
            <div class="box">
              <router-link :to="'/salecar/subsalecar/'+ item.id">
                <img :src="item.carImageList.length == 0 ? 'https://www.kamlung.net:8080/usedcar/upload/usedCar/201922612223.jpg' : url + item.carImageList[0].imageName"/>
                <em>已降{{item.priceCut | MoneyFormat}}</em>
              </router-link>
              <div class="recommends-text">
                <router-link :to="'/salecar/subsalecar/'+ item.id">
                  <span>{{item.title}}</span>
                  <h3>￥<i>{{ Num(item.priceCut, item.price) }}万</i> {{item.price}}万</h3>
                  <!-- <b>万</b> -->
                </router-link>
              </div>
            </div>
            <div class="car-status" v-if="item.status == 3"><span>已售</span></div>
          </div>
        </div>
      </div>
      <!-- 活动特惠/真诚服务 -->
      <div class="news">
        <div class="news-left">
          <h4>
            <span>活动日志</span>
            <router-link to="/aboutdesign/activity" class="i iconfont icon-more-square-circle-o"></router-link>
          </h4>
          <ol>
            <li v-for="(itemActivity, index) in tableDataActivity1.slice(0, 7)" :key="index">
              <router-link :to="'/aboutdesign/details/' + itemActivity.id">
                <p class="ellipsis">{{ itemActivity.title }}</p>
                <strong class="time ellipsis">{{ itemActivity.createTime }}</strong>
              </router-link>
            </li>
          </ol>
          <em></em>
        </div>
        <div class="news-left">
          <h4>
            <span>每日信息</span>
            <router-link to="/aboutdesign/service" class="i iconfont icon-more-square-circle-o"></router-link>
         </h4>
          <ol>
            <li v-for="(itemActivity, index) in tableDataActivity2.slice(0, 7)" :key="index">
              <router-link :to="'/aboutdesign/details/' + itemActivity.id">
                <p class="ellipsis">{{ itemActivity.title }}</p>
                <strong class="time ellipsis">{{ itemActivity.createTime }}</strong>
              </router-link>
            </li>
          </ol>
          <em></em>
        </div>
        <div class="news-right">
          <h4>
            <span>常见问题</span>
            <router-link to="/aboutdesign/problem" class="i iconfont icon-more-square-circle-o"></router-link>
         </h4>
          <ol>
            <li v-for="(itemActivity, index) in tableDataActivity3.slice(0, 7)" :key="index">
              <router-link :to="'/aboutdesign/details/' + itemActivity.id">
                <p class="ellipsis">{{ itemActivity.title }}</p>
                <strong class="time ellipsis">{{ itemActivity.createTime }}</strong>
              </router-link>
            </li>
          </ol>
          <em></em>
        </div>
      </div>
      <!-- 四大策略 -->
      <div class="strategy">
        <a class="strategy-li" v-for="(item, index) in strategy" :key="index" href="javasrcipt:;">
          <div class="padding-15">  
            <div class="padding-left-10">
              <em class="iconPng"></em>
            </div>
            <div class="strategy-right">
              <span>{{item.name}}</span>
              <p>{{item.content}}</p>
            </div>
          </div>
        </a>
      </div>
      <!-- 关于我们 -->
      <FooterAbout/>
    </div>
    <!-- 授权 -->
    <Copy/>
  </div>
</template>

<script>
import { reqCarList, reqCarBrandList, reqActivity, reqBanners, reqAddSaleUser, BASE_URL } from '../api/'
import { isPhone } from '../js/validate.js'
import HeaderTop from '../components/HeaderTop.vue'
import FooterAbout from '../components/FooterAbout.vue'
import Copy from '../components/Copy.vue'
import Swiper from 'swiper'
import Cookies from 'js-cookie'
import moment from 'moment'
import '../js/NumFormat.js'
// import '../js/formatSalary.js'

export default {
  name: 'YscIndex',
  data () {
    return {
      url: BASE_URL + '/usedcar/upload/usedCar/',
      strategy: [
        {name: '焕新服务', content: '名车中心给您“新”一样的体验。'},
        // {name: '质量三保', content: '所有车国内PDI检测，手续齐全，全国联保，售后无忧。'},
        {name: '金融保障', content: '具有强大的金融资源，买好车快捷无忧。'},
        {name: '一对一服务', content: '专业销售顾问一对一服务，为您排忧解难。'},
      ],
      tableCarBrand: [],
      tableCarBrandOther: [],
      Other: '',
      tableRecommend: [], //店长推荐
      tableSale: [], //限时抢购
      tableData: [], //返回的结果集合
      total: 0,
      pages: 1, //当前页
      pageSize: 10, //一页展示多少
      tableDataActivity1: [], //返回的结果集合
      tableDataActivity2: [], //返回的结果集合
      tableDataActivity3: [], //返回的结果集合
      totalActivity: 0,
      pagesActivity: 1, //当前页
      pageSizeActivity: 10, //一页展示多少
      tableDataBanners: [],
      totalBanners: 0,
      pagesBanners: 1, //当前页
      pageSizeBanners: 10, //一页展示多少
      pagesMore: 1, //限制显示多少个
      carPrice: [
        {id: 1, name: '10万以下', minPrice: '0', maxPrice: '10'},
        {id: 2, name: '10-20万', minPrice: '10', maxPrice: '20'},
        {id: 3, name: '20-25万', minPrice: '20', maxPrice: '25'},
        {id: 4, name: '25-30万', minPrice: '25', maxPrice: '30'},
        {id: 5, name: '30-40万', minPrice: '30', maxPrice: '40'},
        {id: 6, name: '40-50万', minPrice: '40', maxPrice: '50'},
        {id: 7, name: '50-60万', minPrice: '50', maxPrice: '60'},
        {id: 8, name: '60万以上', minPrice: '60', maxPrice: ''}
      ],
      carModal: [
        { carTypeId: 0, carTypeName: '经济型车' },
        { carTypeId: 1, carTypeName: '准新车' },
        { carTypeId: 2, carTypeName: '三厢车' },
        { carTypeId: 3, carTypeName: '两厢轿车' },
        { carTypeId: 4, carTypeName: '旅行车' },
        { carTypeId: 5, carTypeName: '越野车' },
        { carTypeId: 6, carTypeName: '性能车' },
        { carTypeId: 7, carTypeName: '商务车' }
      ],
      phoneNoform: {
        phoneNo: '',
        location: '',  
        position: Cookies.get('position') || 2,
      },
      rules:{
        phoneNo: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' },
          { type: 'string', min: 11, message: '手机号不允许小于11位', trigger: 'blur' },
          { validator: isPhone, trigger: 'blur' }
        ]
      },
      loadingMore: false,
      position: Cookies.get('position') || 2,
      month: moment().month() + 1
    }
  },
  mounted(){
  },
  created(){
    const currentPageBanners = this.pagesBanners
    const pageSizeBanners = this.pageSizeBanners
    const activityType = 4
    reqBanners(currentPageBanners, this.totalBanners, activityType, this.position).then(resBanners => {
      if (resBanners.status == true) {
        console.log('tableDataBanners', resBanners)
        this.tableDataBanners = resBanners.data.list
        this.totalBanners = resBanners.data.total
        
        this.$nextTick(function () {
          this.mySwiper()
        })
        console.log('this.tableDataBanners', this.tableDataBanners)
      }
    })

    const currentPage = this.pages
    const pageSize = this.pageSize
    // console.log('currentPage:',currentPage , 'pageSize:',pageSize)
    reqCarList(currentPage, this.total, this.position).then(res=>{
      console.log('this.positionthis.position', this.position)
      if (!res.data.errno) {
        res.data.list.forEach(val => {
          if (val.isRecommend == true) {
            this.tableRecommend.push(val)
          }
          if (val.isFlashSale == true) {
            this.tableSale.push(val)
          }
        })
        
        this.tableData = res.data.list
        this.total = res.data.total
        console.log('tableRecommends', this.tableRecommends)
        
        console.log('tableSales', this.tableSales)
      }
    })
    reqCarBrandList().then(resd=>{
      if (!resd.data.errno) {
      console.log('resdresdresdresdresdresd', resd)
      resd.data.forEach(valOther => {
        // console.log('val', valOther.id)
        if (valOther.id != 91) {
          this.tableCarBrandOther.push(valOther.id)
        }
      })
      // console.info('this.tableCarBrandOther', this.tableCarBrandOther)
      this.Other = this.tableCarBrandOther.join(',')
      console.log('Other', this.Other)
      this.tableCarBrand = resd.data
      this.tableCarBrand.sort((obj1, obj2) => {
        return obj1.sortNo - obj2.sortNo
      })
      }
    })

    const currentPageActivity = this.pagesActivity
    const pageSizeActivity = this.pageSizeActivity
    reqActivity(currentPageActivity, this.totalActivity, this.position).then(resActivity =>{
       if (!resActivity.data.errno) {
        resActivity.data.list.sort((obj1, obj2) => {
          return obj2.id - obj1.id
        })
        resActivity.data.list.forEach(val => {
          if (val.activityType === 1) {
            this.tableDataActivity1.push(val)
          } else if(val.activityType === 2) {
            this.tableDataActivity2.push(val)
          } else if(val.activityType === 3) {
            this.tableDataActivity3.push(val)
          }
        })
        // console.log('this.tableDataActivity1', this.tableDataActivity1)
        // console.log('this.tableDataActivity2', this.tableDataActivity2)
        // console.log('this.tableDataActivity3', this.tableDataActivity3)
        this.totalActivity = resActivity.data.total
      }
      // console.log(resActivity)
    })
  },
  methods:{
    onTo() {
      return this.$router.push({path:'/assessment'})
    },
    onSubmit(event) {
      event.preventDefault()
      let formData = this.phoneNoform
      formData.location = this.position == 1 ? '广州' : '深圳' || '深圳'
      console.log('formData', formData)
      this.$refs['phoneNoform'].validate((valid) => {
        if (valid) {
          reqAddSaleUser(formData).then( res => {
            if (res.status) {
              console.log('提交成功')
              this.$message({
                message: "提交成功！",
                customClass: 'mode',
                type: 'success'
              })
              console.log('reqAddSaleUser',formData)
              // this.$router.back(-1)
            } else {
              this.$message({
                message: "提交失败，请填写对应的内容！",
                customClass: 'mode',
                type: 'error'
              })
              return false
            }
            this.$nextTick(() => {
              this.$refs.phoneNoform.resetFields()
              this.phoneNoform.phoneNo = ''
            })
          })
        } else {  
          this.$message({
            message: "添加失败，请填写对应的内容！",
            customClass: 'mode',
            // duration: 300000,
            type: 'error'
          })
        }
      })
    },
    Num(priceCut, price){
      // console.log('priceCut', priceCut)
      // console.log('price', price)
      var filter = this.$options.filters['NumMoney']
      var pri = Number(filter(priceCut))
      var num = price + pri
      // console.log('pri', num.toString().slice(0, 5))
      return num.toString().slice(0, 5)
    },
    loadBrands() {
      this.loadingMore = true
      setTimeout(()=> {
        this.loadingMore = false
        this.pagesMore += 10
      },200)
    },
    mySwiper() {
      let mySwiper = new Swiper('.swiper-container', {
        direction: 'horizontal',
        autoplay: true,
        loop: true,
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          bulletElement : 'li',
        }
      })
    },
    changeActive($event){
      $event.currentTarget.className="car-left on"
      // console.log('1234')
    },
    removeActive($event){
      $event.currentTarget.className="car-left"
    }
  },
  computed: {
    tableRecommends() {
      return this.tableRecommend.sort((a,b) => {
        return b.id - a.id
      })
    },
    tableSales() {
      return this.tableSale.sort((a,b) => {
        return b.id - a.id
      })
    }
  },
  filters:{
    NumMoney: function(value){
      if(!value) return '0'
      value = value.toFixed(0)
      var intPart = Math.trunc(value)// 获取整数部分
      var intPartFormat
      // var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
      if(intPart.toString().slice(1, 2) == 0 ){
        intPartFormat = intPart.toString().slice(0, 1)
        // console.log('intPart.toString().slice(0, 1)', intPart.toString().slice(1, 2))
      } else{
        intPartFormat = intPart.toString().slice(0, 2)
        // console.log('intPart.toString().slice(0, 2)', intPart.toString().slice(1, 2))
      }
      var floatPart = '0.' // 预定义小数部分
      var value2Array = value
      if(value2Array.length === 5) {
        var value2
        if(value2Array.substr(2, 1) == 0){
          value2 = ''
        } else {
          value2 = value2Array.substr(2, 1)
        }
        return value2Array.substr(0, 1) + '.' + value2Array.substr(1, 1) + value2
      } else if(value2Array.length === 6){
        var value2, value3
        if(value2Array.substr(2, 1) == 0){
          value2 = ''
        } else {
          value2 = value2Array.substr(2, 1)
        }
        if(value2Array.substr(3, 1) == 0){
          value3 = ''
        } else {
          value3 = value2Array.substr(3, 1)
        }

        return value2Array.substr(0, 1) + value2Array.substr(1, 1) + '.' + value2 + value3
      } else {
        // console.log('intPart.toString().slice(1, 2)', intPart.toString().slice(1, 2))
        return floatPart + intPartFormat
      }
    }
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../node_modules/swiper/dist/css/swiper.min.css'

  // 活动特惠/真诚服务
  @media screen and (min-width: 660px) and (max-width: 1199px) 
    .news .news-left, .news .news-right
      width 31% !important
      padding 12px 1% 30px 1% !important
    .strategy .strategy-li
      &:nth-of-type(1)
        margin-left 3% !important
   @media screen and (min-width: 0) and (max-width: 659px) 
    .news .news-left, .news .news-right
      width 94% !important
      padding 12px 3% 30px 3% !important

  // 店长推荐/限时抢购/品牌
  @media screen and (min-width: 660px) and (max-width: 900px) 
    .brands ul li
      width 25% !important
    .strategy .strategy-li
      width 30% !important
      &:nth-of-type(1)
        margin-left 3% !important
    //品牌一栏
    .brand-box,
    .brand-right
      width 100% !important
    .brand-right
      padding 40px 40px 0
      text-align center
  @media screen and (min-width: 528px) and (max-width: 659px) 
    .brands ul li
      width 50% !important
    .strategy .strategy-li
      width 30% !important
      &:nth-of-type(1)
        margin-left 2% !important
    .recommends .recommends-box .recommends-li,
    .sale .recommends-box .recommends-li
      width 49% !important

    //品牌一栏
    .brands
      .brand-box,
      .brand-right
        width 100% !important
      .brand-right
        padding 40px 40px 0 !important
        text-align center !important

  @media screen and (min-width: 0px) and (max-width: 658px)
    //品牌一栏
    .brands
      .brand-box,
      .brand-right
        width 100% !important
      .brand-box
        .box
          display block !important
          .car-left
            border-right none !important
            padding-bottom 10px !important
          .car-left,
          .car-price,
          .car-modal
            width 100% !important
      .brand-right
        padding-left 0 !important
        padding 30px 10px 0 !important
        text-align center 

  @media screen and (min-width: 200px) and (max-width: 527px) 
    .swiper
      .swiper-slide
        width 100% !important
        padding-bottom 50% !important
        img
          width 150% !important
          position absolute
          left -18%
    .brands ul li
      width 50% !important
    .strategy .strategy-li
      width 94% !important
      margin-right 0 !impor tant
      padding 0 3%
      &:nth-of-type(1)
        margin-left 0 !important
    .recommends .recommends-box .recommends-li,
    .sale .recommends-box .recommends-li
      width 49% !important
 
 
  .swiper
    .swiper-slide
      overflow hidden
      width 100%
      height 0
      padding-bottom 35%
      img
        width 100%
  .brands,
  .recommends,
  .sale
    float left
    width 100% 
    margin 80px 0 58px
    .brands-more
      overflow hidden
      font-size 16px
      width 100px
      padding 8px 46px
      border-radius 2px
      background #dfdfdf
      cursor pointer
      text-align center
      display block
      margin 10px auto 0
      span
        margin-left 5px
      &:hover
        background #ccc
        transition 0.5s all
        -webkit-transition 0.5s all
        -moz-transition 0.5s all
        -o-transition 0.5s all
        -ms-transition 0.5s all
    .brands-more-else
      font-size 14px
      background #fff
      &:hover
        background #fff
    .title
      text-align center
      margin-bottom 15px
      h2
        font-size 22px
        color #2b2b2b
      p
        font-size 14px
        margin-top 8px
        color #737373
    .brand-box,
    .brand-right
      width 70%
      font-size 14px
      // border 1px solid rgba(0,0,0,.1)
      border-radius 4px
      box-sizing border-box
      background-color #fff
      overflow hidden
      float left
      // display inline-block
      // box-shadow 0 0 12px rgba(0,0,0,.1)
      // -webkit-box-shadow 0 0 12px rgba(0,0,0,.1)
      // -moz-box-shadow 0 0 12px rgba(0,0,0,.1)
      // -o-box-shadow 0 0 12px rgba(0,0,0,.1)
      // -ms-box-shadow 0 0 12px rgba(0,0,0,.1)
      .car-brand,
      .car-price,
      .car-modal
        width 100%
        ul
          float left
          width 100%
          li
            // display inline-block
            float left
            text-align center
            margin-bottom 26px
            i
              height 86px
              font-size 38px
              color #cfcfcf
              display flex
              justify-content center
              flex-direction column
            &.on
              i
                color #f75555
      
      .box
        font-size 16px
        width 100%
        height 100px
        display flex 
        .car-left
          width 26%
          float left
          text-align center
          border-right 2px solid #ccc
          img
            height 70px
            display block
            margin 0 auto
          i
            height 74px
            font-size 38px
            color #cfcfcf
            display flex
            justify-content center
            flex-direction column
          &.on
            i
              color #f75555
            .current
              color #f75555
              
        
      // .car-brand
      //   width 20%
      //   float: left;
      //   ul
      //     li
      //       width 100%
      //       // margin-left -1px

      .car-price,
      .car-modal
        width 70%
        float left   
        display flex
        flex-direction column
        justify-content center
        ul
          li
            width 25%
            margin 10px 0
            a
              color #222
              &:hover
                color #f75555
    .brand-right
      width 30%
      border-left 0px
      padding-top 20px
      padding-left 40px
      h5
        font-size 20px
        margin-bottom 10px 
      p
        font-size 14px
        color #888
        margin-bottom 14px 
      .brand-right-text
        input[type="text"]
          width 80%
          height 36px 
          font-size 16px
          // letter-spacing 3px
          border-radius 2px
          padding-left 8px 
          border 1px solid #ccc
      .brand-right-buttom
        margin-top 24px
        input[type="button"]
          height 42px
          font-size 15px
          background #fff
          color #d81240
          border 1px solid #d81240
          border-radius 2px
          padding 0 20px
          margin-right 10px
          cursor pointer
      
    // ul
    //   float left
    //   width 100%
    //   li
    //     float left
    //     width 20%
    //     margin-bottom 22px
    //     // padding 28px 0
    //     text-align center
    //     position relative
    //     top 0
    //     left 0
    //     img
    //       height 120px
    //     &.on
    //       .current
    //         display flex !important
    //         &:hover
    //           background:rgba(0,0,0,.6)
    //           &:after
    //             opacity 1
    //     .current
    //       width 100%
    //       height 100%
    //       display none
    //       flex-direction column
    //       justify-content center
    //       text-align center
    //       font-size 16px
    //       color #fff
    //       font-weight 600
    //       letter-spacing 2px
    //       position absolute
    //       left 0
    //       top 0
    //       background:rgba(0,0,0,0)
    //       transition 0.5s all
    //       -webkit-transition 0.5s all
    //       -moz-transition 0.5s all
    //       -o-transition 0.5s all
    //       -ms-transition 0.5s all
    //       &:after
    //         display block
    //         content '点击进入'
    //         font-size 12px
    //         width 50%
    //         height 30px
    //         display flex
    //         flex-direction column
    //         justify-content center
    //         text-align center
    //         margin 10px auto 0
    //         border-radius 50px
    //         background #d81240
    //         opacity 0
    //         transition 0.5s all
    //         -webkit-transition 0.5s all
    //         -moz-transition 0.5s all
    //         -o-transition 0.5s all
    //         -ms-transition 0.5s all
  
  // .brands
  //   margin 80px 0 58px
  .recommends,
  .sale
    width 100%
    .recommends-box
      float left    
      margin-top 14px
      padding-bottom 6px
      .recommends-li
        width 24%
        float left
        background #fff
        margin-right 1%
        transition 0.5s all
        -webkit-transition 0.5s all
        -moz-transition 0.5s all
        -o-transition 0.5s all
        -ms-transition 0.5s all
        box-sizing border-box
        position relative
        overflow hidden
        &:nth-of-type(4)
          padding-right 0
        .car-status
          height 40%
          color #fff
          padding 0 16px
          display flex
          flex-direction column
          justify-content center
          position absolute
          bottom 0
          right 0
          transform skewX(-48deg)
          background #e40a0a
          letter-spacing 1px
          box-shadow 8px 0 6px #ccc
          cursor pointer
          span
            transform skewX(48deg)
            font-size 18px
            margin-top 50%
        .box
          width 100%
          border 1px #eee solid
          a
            position relative
            em
              background #d81240
              color #fff
              font-size 14px
              font-style normal
              padding 6px 10px
              position absolute
              top 0
              left 0
              
        &:hover
          transform translate3d(0,-4px,0)
          -webkit-box-shadow 0 10px 10px rgba(0,0,0,.1)
          -moz-box-shadow 0 10px 10px rgba(0,0,0,.1)
          box-shadow 0 10px 10px rgba(0,0,0,.1)
          position relative
          z-index 9999
          font-weight normal
        a
          display block
          padding 2px
          img 
            width 100%
        .recommends-text 
          width 100%
          overflow hidden
          position relative
          background #fff
          margin-top 2px
          border-top 1px solid #eee
          a
            overflow hidden
            padding 10px
            & span:hover,
            & span:focus
              color #f75555
              text-decoration none
            span,h3
              font-weight 600
            span
              font-size 14px
              color #222
              display block
              transition 0.5s all
              -webkit-transition 0.5s all
              -moz-transition 0.5s all
              -o-transition 0.5s all
              -ms-transition 0.5s all
            h3,b
              float left
              line-height: 1.7
            h3 
              font-size 16px
              color #d81240
              margin-bottom 18px
              i
                font-style normal
                // text-decoration line-through
                margin-right 2px
                padding 0 2px
                position relative
                top 0
                left 0
                &:after
                  display block
                  content ''
                  width 100%
                  height 1px
                  background #d81240
                  position absolute
                  top 36%
                  left 0
                  z-index 99
                &:before
                  display block
                  content ''
                  width 100%
                  height 1px
                  background #d81240
                  position absolute
                  top 62%
                  left 0
                  z-index 99
            b    
              font-size 12px
              margin-top 4px
              margin-left 4px
              color #807b7b
  // 活动
  .news
    width 100%
    float left
    overflow hidden
    margin-top 20px
    border-top 1px solid #ccc
    .news-left,
    .news-right
      width 340px
      padding 12px 30px 30px 30px
      float left
      h4
        font-size 18px
        height 24px
        line-height 24px
        margin-bottom 16px
        span
          padding 3px 12px
          float left
      .i 
        font-size 18px
        margin-right 10px
        float right
        color #2b2b2b
      em
        width 90%
        display block
        padding 4px 0
        text-align left
        // border-bottom 1px solid #ccc
      ol
        width 100%
        height 120px
        overflow hidden
        li
          height 24px
          position relative
          a
            display block
            color #151515
            &:hover
              color #f75555
          p,strong
            line-height 20px
          strong
            width 25%
            position absolute
            top 0
            right 0
            text-align center
          p
            width 75%
            display inline-block
    .news-left
       h4 
        span
          color #fff
          background #000
    .news-right
       h4 
        span
          border-bottom 1px solid #ccc
  // 四大策略
  .strategy
    .strategy-li
      width 30%
      float left
      margin-right 2%
      &:nth-of-type(1)
        margin-left 4%
      .padding-15
        padding 15px 0 15px 0
      .padding-left-10
        padding 0 10px 0 0
        display table-cell
        vertical-align top
      .iconPng
        display block
        width 54px
        height 54px
        background url(../images/icon.png) no-repeat
        background-size 100px
        background-position 0 0
        transition background-position 0.3s
        -moz-transition background-position 0.3s
        -webkit-transition background-position 0.3s
        -o-transition background-position 0.3s
      // &:nth-of-type(1) .iconPng
      //   background-position 0 -324px
      &:nth-of-type(2) .iconPng
        background-position 0 -108px
      &:nth-of-type(3) .iconPng
        background-position 0 -216px
      .strategy-right
        display table-cell
        vertical-align: top
        color #999
        span
          color #222
          font-size 18px
          font-weight 600
          transition 0.5s all
          -webkit-transition 0.5s all
          -moz-transition 0.5s all
          -o-transition 0.5s all
          -ms-transition 0.5s all
        p  
          font-size 13px
          letter-spacing 0.4px
          transition 0.5s all
          -webkit-transition 0.5s all
          -moz-transition 0.5s all
          -o-transition 0.5s all
          -ms-transition 0.5s all
      &:hover,
      &:focus
        .iconPng
          display block
          width 54px
          height 54px
          background url(../images/icon.png) no-repeat
          background-position 0 -54px
          background-size 100px
          transition background-position 0.3s
          -moz-transition background-position 0.3s
          -webkit-transition background-position 0.3s
          -o-transition background-position 0.3s
        // &:nth-of-type(1) .iconPng
        //   background-position 0 -378px
        &:nth-of-type(2) .iconPng
          background-position 0 -162px
        &:nth-of-type(3) .iconPng
          background-position 0 -270px
        .strategy-right
          display table-cell
          vertical-align top
          span
            font-weight 600
            color #f75555
            text-decoration none
          p
            font-size 13px
            font-weight 600
            color #f75555
            text-decoration none
      
</style>

<style>
  .swiper .swiper-pagination .swiper-pagination-bullet{
    border-radius: 10px;
    width: 60px;
    height: 8px;
    background: #999;
    opacity: 1;
    margin: 4px
  }
  .swiper .swiper-pagination .swiper-pagination-bullet-active{
    width: 60px;
    height: 8px;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/YscIndex.vue